export default {"src":"/_next/static/media/check_black_icon.944ed055.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};